import { analyticsMenuItems } from '../constants/navigationPanel';

export function useAnalyticsMenuItems() {
  return {
    sidebarMenuItems: analyticsMenuItems(),
  };
}
